








import {Component, Vue, Inject, Prop} from 'vue-property-decorator';
import {SubcomponentRow} from '@/models/FlexGridModel';

@Component
export default class FlexGridTableSubcomponentRow extends Vue {
    @Inject() moduleName!: string;
    @Inject() subcomponent!: Object | undefined;
    @Prop() info!: SubcomponentRow;

    get groupColspan(): number {
        return this.$store.getters[`${this.moduleName}/groupColspan`];
    }
    get emptyCellsCount(): number {
        return this.$store.getters[`${this.moduleName}/emptyCellsCount`];
    }
    get hasSubcomponents(): number {
        return this.$store.getters[`${this.moduleName}/hasSubcomponents`];
    }
}
